import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}/admin`;

class ClientsService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getAllClients() {
    try {
      const response = await axios.get(
        `https://api.tripsecuregh.com/api/admin/all/clients`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Clients fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting clients",
      };
    }
  }

  async getClientsByAgent(agentSlug) {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/agent/clients/${agentSlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Clients fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting clients",
      };
    }
  }

  async activateClient(clientSlug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/activate/client/${clientSlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Client activated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while activating client",
      };
    }
  }

  async updateClient(clientSlug, payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/update/registered_client/${clientSlug}`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Client updated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while updating client",
        validationErrors: error.response?.data?.errors || null,
      };
    }
  }
}

const clientsService = new ClientsService();
export default clientsService;
